import GET from "./GET";

const store = {
  USER_ID_KEY: "disco-userId",

  checkLocalStorage() {
    const test = "coop-test-7849js838yrh84yh";
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  },

  getItem(key) {
    if (!this.checkLocalStorage()) {
      return null;
    }

    return window.localStorage.getItem(key);
  },

  setItem(key, value) {
    if (!this.checkLocalStorage()) {
      return;
    }

    return window.localStorage.setItem(key, value);
  },

  get userId() {
    return this.getItem(this.USER_ID_KEY) || null;
  },
  set userId(userId) {
    this.setItem(this.USER_ID_KEY, userId);
  },

  makeKey(key) {
    return "disco-" + key;
  },

  backedGET(key) {
    const val = GET(key);
    if (val) {
      this.setItem(this.makeKey(key), val);
      return val;
    }
    if (this.getItem(this.makeKey(key))) return this.getItem(this.makeKey(key));

    return null;
  },
};

export default store;
